module.exports = __webpack_public_path__ + "static/media/team-member-1.6bcac7e8.png";